<form [formGroup]="popinForm">
  <div mat-dialog-title>
    <app-dialog-close-cross></app-dialog-close-cross>
    <h2 id="RecipesSearchCopySourceTitleTxt">{{ 'COPY_RECIPES_MARKET.MODAL.TITLE' | translate }}</h2>
  </div>
  <mat-dialog-content>
    <div class="grid-container">
      <div class="grid-item">
        <mat-card>
          <mat-card-header class="card-header">
            <mat-card-title
              ><h2 class="grid-item-title">{{ 'COPY_RECIPES_MARKET.MODAL.SOURCE' | translate }}</h2>
            </mat-card-title>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content class="card-container">
            <div class="grid-item-content">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>{{ 'COPY_RECIPES_MARKET.MODAL.DOMAIN' | translate }}</mat-label>
                <input matInput id="RecipesSearchCopySourceDomainTxt" value="{{ data.domain.label }}" disabled />
              </mat-form-field>
            </div>

            <div class="grid-item-content">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>{{ 'COPY_RECIPES_MARKET.MODAL.MARKET' | translate }}</mat-label>
                <input matInput id="RecipesSearchCopySourceMarketTxt" value="{{ data.market.label }}" disabled />
              </mat-form-field>
            </div>
            <div class="grid-item-content">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>{{ 'COPY_RECIPES_MARKET.MODAL.LANG' | translate }}</mat-label>
                <input matInput id="RecipesSearchCopySourceLangTxt" value="{{ data.lang.label }}" disabled />
              </mat-form-field>
            </div>

            <div class="grid-item-content">
              <mat-form-field appearance="fill" subscriptSizing="dynamic" class="full-width">
                <mat-label> {{ 'COPY_RECIPES_MARKET.MODAL.STATUS' | translate }}</mat-label>
                <mat-select
                  id="RecipesSearchCopySourceStatusBtn"
                  formControlName="sourceStatus"
                  #selectStatus
                  placeholder="{{ (selectStatus.value ? 'STATUS' : 'SELECT_STATUS') | translate }}"
                >
                  <div id="RecipesSearchCopySourceStatusLst">
                    <mat-option [value]="null"></mat-option>
                    <mat-option class="custom-mat-option" *ngFor="let selection of data.statuses" [value]="selection.key">
                      {{ selection.translatedName }}
                    </mat-option>
                  </div>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="grid-item">
        <mat-card>
          <mat-card-header class="card-header">
            <mat-card-title
              ><h2 class="grid-item-title">{{ 'COPY_RECIPES_MARKET.MODAL.TARGET' | translate }}</h2>
            </mat-card-title>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content class="card-container">
            <div class="grid-item-content">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>{{ 'COPY_RECIPES_MARKET.MODAL.DOMAIN' | translate }}</mat-label>
                <input matInput id="RecipesSearchCopyTargetDomainTxt" value="{{ data.domain.label }}" disabled />
              </mat-form-field>
            </div>
            <div class="grid-item-content">
              <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                <mat-label> {{ 'COPY_RECIPES_MARKET.MODAL.MARKET' | translate }}</mat-label>
                <mat-select
                  id="RecipesSearchCopyTargetMarketBtn"
                  formControlName="targetMarket"
                  #selectMarket
                  placeholder="{{ (selectMarket.value ? 'MARKET' : 'SELECT_MARKET') | translate }}*"
                >
                  <div id="RecipesSearchCopyTargetMarketLst">
                    <mat-option [value]="null"></mat-option>
                    <mat-option
                      *ngFor="let selection of data.filteredData.filteredMarkets | sortBy : 'translatedName' : 'ASC'"
                      [value]="selection"
                    >
                      {{ selection.translatedName }}
                    </mat-option>
                  </div>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="grid-item-content">
              <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                <mat-label> {{ 'COPY_RECIPES_MARKET.MODAL.LANG' | translate }}</mat-label>
                <mat-select
                  id="RecipesSearchCopyTargetLangBtn"
                  formControlName="targetLang"
                  #selectLang
                  placeholder="{{ (selectLang.value ? 'LANGUAGE' : 'SELECT_LANGUAGE') | translate }}*"
                >
                  <div id="RecipesSearchCopyTargetLangLst">
                    <mat-option [value]="null"></mat-option>
                    <mat-option
                      *ngFor="let selection of data.filteredData.filteredLanguages | sortBy : 'translatedName' : 'ASC'"
                      [value]="selection"
                    >
                      {{ selection.translatedName }}
                    </mat-option>
                  </div>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div>
      <mat-checkbox class="space-h-s" id="RecipesSearchCopyTranslateChkBox" formControlName="translationRequested">{{
        'COPY_RECIPES.MODAL.TRAD_VAR' | translate
      }}</mat-checkbox>
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <div class="footer-popin" mat-dialog-actions>
    <button class="space-h-s btn-warn" mat-raised-button id="RecipesSearchCopyCancelBtn" (click)="cancel()">
      {{ 'CANCEL' | translate }}
    </button>
    <button class="space-h-s btn-submit" mat-raised-button id="RecipesSearchCopyCopyBtn" (click)="submit()" [disabled]="popinForm.invalid">
      {{ 'COPY_RECIPES.MODAL.BTN_COPY' | translate }}
    </button>
  </div>
</form>
